import { render } from "./PricesTasksStage.vue?vue&type=template&id=a7b40692&scoped=true"
import script from "./PricesTasksStage.vue?vue&type=script&lang=js"
export * from "./PricesTasksStage.vue?vue&type=script&lang=js"

import "./PricesTasksStage.vue?vue&type=style&index=0&id=a7b40692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b40692"]])

export default __exports__